
export const MONTH_MAP = {
    'Jan': '01',
    'Fev': '02',
    'Mar': '03',
    'Abr': '04',
    'Mai': '05',
    'Jun': '06',
    'Jul': '07',
    'Ago': '08',
    'Set': '09',
    'Out': '10',
    'Nov': '11',
    'Dez': '12'
  };
  
  /**
   * Configuração padrão de filtros para dashboards
   * @returns {Array} Array de objetos de filtro
   */
  export function createDefaultFilters() {
    return [
      {
        key: 'year',
        label: 'Ano',
        value: 'Todos',
        options: ['Todos', '2023', '2024', '2025']
      },
      {
        key: 'month',
        label: 'Mês',
        value: 'Todos',
        options: ['Todos', 'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
      },
      {
        key: 'day',
        label: 'Dia',
        value: 'Todos',
        options: ['Todos'].concat(Array.from({ length: 31 }, (_, i) => String(i + 1)))
      },
      // {
      //   key: 'shift',
      //   label: 'Turno',
      //   value: 'Todos',
      //   options: ['Todos']
      // },
      {
        key: 'area',
        label: 'Área',
        value: 'Todos',
        options: ['Todos']
      },
      {
        key: 'resource',
        label: 'Recurso',
        value: 'Todos',
        options: ['Todos']
      }
    ];
  }
  
  /**
   * Obtém o valor de um filtro específico por key
   */
  export function getFilterValue(filters, key) {
    return filters.find(f => f.key === key)?.value || 'Todos';
  }
  
  /**
   * Define o valor de um filtro específico
   */
  export function setFilterValue(filters, key, value) {
    const filter = filters.find(f => f.key === key);
    if (filter) {
      filter.value = value;
    }
  }
  
  /**
   * Atualiza as opções de um filtro específico
   */
  export function updateFilterOptions(filters, key, options, keepTodos = true) {
    const filter = filters.find(f => f.key === key);
    if (filter) {
      filter.options = keepTodos ? ['Todos', ...options] : options;
    }
  }
  
  /**
   * Reseta todos os filtros para 'Todos'
   */
  export function clearAllFilters(filters) {
    filters.forEach(filter => {
      filter.value = 'Todos';
    });
  }
  
  /**
   * Converte filtros de data em range de datas (StartDate/EndDate)
   */
  export function getDateRangeFromFilters(filterValues) {
    const { year, month, day } = filterValues;
  
    // Se todos são 'Todos', não retorna filtro de data
    if ((!year || year === 'Todos') && (!month || month === 'Todos') && (!day || day === 'Todos')) {
      return null;
    }
  
    const currentDate = new Date();
    const currentYear = year && year !== 'Todos' ? year : currentDate.getFullYear();
  
    // CASO 1: Apenas ano selecionado
    if ((!month || month === 'Todos') && (!day || day === 'Todos') && year && year !== 'Todos') {
      return {
        StartDate: `${year}-01-01`,
        EndDate: `${year}-12-31`
      };
    }
  
    // CASO 2: Apenas mês selecionado (usa ano atual)
    if ((!year || year === 'Todos') && month && month !== 'Todos' && (!day || day === 'Todos')) {
      const monthNumber = MONTH_MAP[month];
      const lastDay = new Date(currentYear, parseInt(monthNumber), 0).getDate();
      const lastDayFormatted = String(lastDay).padStart(2, '0');
      
      return {
        StartDate: `${currentYear}-${monthNumber}-01`,
        EndDate: `${currentYear}-${monthNumber}-${lastDayFormatted}`
      };
    }
  
    // CASO 3: Apenas dia selecionado (usa mês e ano atual)
    if ((!year || year === 'Todos') && (!month || month === 'Todos') && day && day !== 'Todos') {
      const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
      const dayFormatted = String(day).padStart(2, '0');
      
      return {
        StartDate: `${currentYear}-${currentMonth}-${dayFormatted}`,
        EndDate: `${currentYear}-${currentMonth}-${dayFormatted}`
      };
    }
  
    const monthNumber = MONTH_MAP[month];
  
    // CASO 4: Ano e mês selecionados, mas não dia
    if (year && year !== 'Todos' && month && month !== 'Todos' && (!day || day === 'Todos')) {
      const lastDay = new Date(year, parseInt(monthNumber), 0).getDate();
      const lastDayFormatted = String(lastDay).padStart(2, '0');
      
      return {
        StartDate: `${year}-${monthNumber}-01`,
        EndDate: `${year}-${monthNumber}-${lastDayFormatted}`
      };
    }
  
    // CASO 5: Ano, mês e dia selecionados
    if (year && year !== 'Todos' && month && month !== 'Todos' && day && day !== 'Todos') {
      const dayFormatted = String(day).padStart(2, '0');
      
      return {
        StartDate: `${year}-${monthNumber}-${dayFormatted}`,
        EndDate: `${year}-${monthNumber}-${dayFormatted}`
      };
    }
  
    // CASO 6: Mês e dia selecionados (usa ano atual)
    if ((!year || year === 'Todos') && month && month !== 'Todos' && day && day !== 'Todos') {
      const dayFormatted = String(day).padStart(2, '0');
      
      return {
        StartDate: `${currentYear}-${monthNumber}-${dayFormatted}`,
        EndDate: `${currentYear}-${monthNumber}-${dayFormatted}`
      };
    }
  
    return null;
  }
  
  /**
   * Obtém todos os filtros ativos como objeto
   */
  export function getActiveFilters(filters) {
    return filters.reduce((acc, filter) => {
      acc[filter.key] = filter.value;
      return acc;
    }, {});
  }
  
  /**
   * Parse seguro de JSON
   */
  export function safeJSONParse(value) {
    try {
      return value ? JSON.parse(value) : null;
    } catch (error) {
      console.error('Erro ao fazer parse de JSON:', error);
      return null;
    }
  }